import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames/bind';
import styles from './info-link-box.scss';

const cx = classNames.bind(styles);

export const InfoBoxLink = ({
  title,
  href
}) => {

  return (
    <div>
      <a
        className={cx('service-reviews')}
        href={href}
        target="_blank"
        rel="noreferrer"
      >
        <p>{title}</p>
        <img
          className={cx('service-reviews__next-icon')}
          src="https://assets.homedepot-static.com/images/v1/next-arrow-orange.svg"
          alt={`Click here to go to ${title} page`}
          width="15px"
          height="10px"
        />
      </a>
    </div>
  );
};

InfoBoxLink.propTypes = {
  title: string.isRequired,
  href: string
};

InfoBoxLink.defaultProps = {
  href: ''
};